import { useCallback, useEffect, useState } from "react";
import { getTrackingInfo } from "../../store/action/tracker";

export function useOpenTracking(opt = {}) {
  /** @type {[import("../../store/action/tracker").TrackingInfo, Function]} */
  const [tracking, setTracking] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getOpenTracking = useCallback(() => {
    setLoading(true);
    getTrackingInfo(opt)
      .then((responseJSON) => setTracking(responseJSON))
      .catch((error) => {
        setError(error?.response?.data?.error || error?.message);
        console.log(error?.response?.data?.error || error?.message);
      })
      .finally(() => setLoading(false));
  }, [opt.trackingId, opt.environment]);

  useEffect(getOpenTracking, [opt.trackingId, opt.environment]);

  return {
    tracking,
    loading,
    error,
  };
}
